import api from "../../../services/api";

const APIS = {
    GET_USER_ROLE: "/Users/role",
    SUBMIT_FEED_ASSAY: "/Sample/addsampleforcustomer",
    EDIT_SAMPLE: "/Sample/edit-assigned-sample-to-customer",
    GET_UNITS: "/Units",
    GET_PRODUCT_TRADES: "/ProductTypes/getproducttrades",
    GET_PRODUCTS_BY_TRADE_ID: "/ProductTypes/getproductsbytradeid",
    GET_FEED_TYPE_BY_TRADE_AND_PRODUCT: "/ProductTypes/getfeedtypebytradeandproduct",
    GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED: "/ProductTypes/getspeciesbytradeandproductandfeed",
    GET_PRODUCT_CONFIGURATION: "/ProductTypes/getproductConfiguration"
};

export const getUserRole = async () => {
    try {
        const response = await api.get(APIS.GET_USER_ROLE);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch user role:', error);
        throw error;
    }
};

export const getEditSampleData = async (sampleId) => {
    try {
        const response = await api.get(`${APIS.EDIT_SAMPLE}?sampleId=${sampleId}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch edit sample data:', error);
        throw error;
    }
};

export const formatUserDetails = (data) => {
    if (!data || typeof data !== 'object') {
        return {
            email: '',
            name: '',
            roleName: [],
            companyName: '',
            companyId: null,
            locations: [],
            salesRep: '',
            customerId: null
        };
    }

    return {
        email: data.email || '',
        name: data.name || '',
        roleName: Array.isArray(data.roleName) ? data.roleName : [],
        companyName: data.companyName || '',
        companyId: data.companyId || null,
        locations: Array.isArray(data.locations) ? data.locations : [],
        salesRep: data.salesRep || '',
        customerId: data.userID || null
    };
};

export const submitFeedAssayRequest = async (userDetails, samples, isEdit = false) => {
    try {
        const payload = formatSampleData(userDetails, samples, isEdit);
        const response = await api.post(APIS.SUBMIT_FEED_ASSAY, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to submit feed assay request:', error);
        if (error.response && error.response.status === 400) {
            console.error('Validation errors:', error.response.data);
        }
        throw error;
    }
};

export const getUnits = async () => {
    try {
        const response = await api.get(APIS.GET_UNITS);
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.map(unit => ({
            id: unit.unitId,
            name: unit.name,
            description: unit.description,
            isActive: unit.isActive
        })).filter(unit => unit && unit.id && unit.name);
    } catch (error) {
        console.error('Failed to fetch units:', error);
        return [];
    }
};

export const getProductTrades = async () => {
    try {
        const response = await api.get(APIS.GET_PRODUCT_TRADES);
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(trade => trade && trade.productTradeNameId && trade.productTradeName);
    } catch (error) {
        console.error('Failed to fetch product trades:', error);
        return [];
    }
};

export const getProductsByTradeId = async (productTradeId) => {
    try {
        if (!productTradeId || isNaN(productTradeId)) {
            console.error(`Invalid productTradeId: ${productTradeId}`);
            return [];
        }

        // Fallback to POST method
        const response = await api.post(`${APIS.GET_PRODUCTS_BY_TRADE_ID}?ProductTradeId=${productTradeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }

        return response.data.filter(type => type && type.productTypeId && type.name);
    } catch (error) {
        console.error('Failed to fetch products by trade id:', error);
        if (error.response && error.response.status === 400) {
            console.error('API validation error:', error.response.data);
        }
        return [];
    }
};

export const getFeedTypeByTradeAndProduct = async (productTradeId, productTypeId) => {
    try {
        if (!productTradeId || !productTypeId || isNaN(productTradeId) || isNaN(productTypeId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}`);
            return [];
        }

        // Fallback to POST method
        const response = await api.post(`${APIS.GET_FEED_TYPE_BY_TRADE_AND_PRODUCT}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }

        return response.data.filter(feed => feed && feed.feedTypeId && feed.feedTypeName);
    } catch (error) {
        console.error('Failed to fetch feed types:', error);
        if (error.response && error.response.status === 400) {
            console.error('API validation error:', error.response.data);
        }
        return [];
    }
};

export const getSpeciesByTradeAndProductAndFeed = async (productTradeId, productTypeId, feedTypeId) => {
    try {
        if (!productTradeId || !productTypeId || !feedTypeId ||
            isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}, feedTypeId: ${feedTypeId}`);
            return [];
        }

        // Fallback to POST method
        const response = await api.post(`${APIS.GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }

        return response.data.filter(s => s && s.speciesId && s.speciesName);
    } catch (error) {
        console.error('Failed to fetch species by trade, product and feed:', error);
        if (error.response && error.response.status === 400) {
            console.error('API validation error:', error.response.data);
        }
        return [];
    }
};

export const getProductConfiguration = async (productTradeId, productTypeId, feedTypeId, speciesId) => {
    try {
        if (!productTradeId || !productTypeId || !feedTypeId || !speciesId ||
            isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId) || isNaN(speciesId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}, feedTypeId: ${feedTypeId}, speciesId: ${speciesId}`);
            return {};
        }

        // Fallback to POST method
        const response = await api.post(`${APIS.GET_PRODUCT_CONFIGURATION}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}&speciesId=${speciesId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data || {};
    } catch (error) {
        console.error('Failed to fetch product configuration:', error);
        if (error.response && error.response.status === 400) {
            console.error('API validation error:', error.response.data);
        }
        return {};
    }
};

export const formatEditSampleData = (apiData) => {
    if (!apiData || typeof apiData !== 'object') {
        return {
            companyId: null,
            locationId: null,
            phibroRep: null,
            customerId: null,
            companyName: '',
            locationName: '',
            phibroRepName: '',
            samples: []
        };
    }

    return {
        companyId: apiData.companyId || null,
        locationId: apiData.locationId || null,
        phibroRep: apiData.phibroRep || null,
        customerId: apiData.customerId || null,
        companyName: apiData.companyName || '',
        locationName: apiData.locationName || '',
        phibroRepName: apiData.phibroRepName || '',
        samples: Array.isArray(apiData.samples) ? apiData.samples.map((sample, index) => {
            if (!sample || typeof sample !== 'object') {
                return null;
            }

            // Helper function to format date to YYYY-MM-DD format for HTML date input
            const formatDateForInput = (dateValue) => {
                if (!dateValue) return "";
                
                // Handle MM/DD/YYYY format
                if (typeof dateValue === 'string' && dateValue.includes('/')) {
                    const parts = dateValue.split('/');
                    if (parts.length === 3) {
                        const [month, day, year] = parts;
                        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                    }
                }
                
                // Handle ISO 8601 UTC format (YYYY-MM-DDTHH:MM:SSZ)
                // Parse as UTC and convert to local timezone
                if (typeof dateValue === 'string' && dateValue.includes('T')) {
                    const date = new Date(dateValue);
                    if (!isNaN(date.getTime())) {
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        return `${year}-${month}-${day}`;
                    }
                }
                
                // Handle plain date format YYYY-MM-DD
                if (typeof dateValue === 'string' && dateValue.includes('-')) {
                    const datePart = dateValue.substring(0, 10);
                    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
                        return datePart;
                    }
                }
                
                return "";
            };

            // Get manufacture date from API response
            const mfgDate = sample.manufactureDate || "";
            const formattedMfgDate = formatDateForInput(mfgDate);
            
                   
            return {
                id: index + 1,
                sampleId: sample.sampleId || 0,
                expanded: true,
                productTradeName: sample.productTradeNameId?.toString() || "",
                productType: sample.productTypeId?.toString() || "",
                feedType: sample.feedTypeId?.toString() || "",
                species: sample.speciesId?.toString() || "",
                unit: sample.unitId?.toString() || "",
                expectedLevel: sample.expectedLevel?.toString() || "",
                phibroLots: sample.lotNumber || "",
                customerSampleId: sample.customerSampleId || "",
                referenceNo: sample.referenceNo || "",
                manufactureDate: formattedMfgDate || "",
                barcodeNumber: sample.barcodeNumber || "",
                remarks: sample.remarks || "",
                cfrMinLevel: sample.cfrMinLevel || "",
                cfrMaxLevel: sample.cfrMaxLevel || "",
                loqValue: sample.loqValue || "",
                isProductTypeEnabled: !!sample.productTradeNameId,
                isFeedTypeEnabled: !!sample.productTradeNameId && !!sample.productTypeId,
                isSpeciesEnabled: !!sample.productTradeNameId && !!sample.productTypeId && !!sample.feedTypeId,
                errors: {
                    productTradeName: "",
                    productType: "",
                    feedType: "",
                    species: "",
                    unit: "",
                    expectedLevel: "",
                    phibroLots: "",
                    customerSampleId: "",
                }
            };
        }).filter(sample => sample !== null) : []
    };
};

const formatSampleData = (userDetails, samples, isEdit = false) => {
    return {
        companyId: userDetails.companyId,
        locationId: userDetails.locationId || 0,
        phibroRep: userDetails.phibroRep,
        customerId: userDetails.customerId,
        sampleRequstedBy: userDetails.email || '',
        samples: (samples || []).map((sample) => ({
            sampleId: isEdit ? (sample.sampleId || 0) : 0,
            productTradeNameId: parseInt(sample.productTradeName) || 0,
            productTypeId: parseInt(sample.productType) || 0,
            feedTypeId: parseInt(sample.feedType) || 0,
            unitId: parseInt(sample.unit) || 0,
            speciesId: parseInt(sample.species) || 0,
            locationId: userDetails.locationId || 0,
            companyId: userDetails.companyId,
            lotNumber: sample.phibroLots || "",
            customerSampleId: sample.customerSampleId || "",
            referenceNo: sample.referenceNo || "",
            manufactureDate: sample.manufactureDate || null,
            barcodeNumber: sample.barcodeNumber || "",
            expectedLevel: sample.expectedLevel || "",
            cfrMinLevel: sample.cfrMinLevel || "",
            cfrMaxLevel: sample.cfrMaxLevel || "",
            loqValue: sample.loqValue || "",
            salesRepId: 1,
            remarks: sample.remarks || "",
            AssayResult: ""
        }))
    };
};
